module.exports = __webpack_public_path__ + "img/crew_upgrade1_7-7-2021.4b7e38fd.jpg";